var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,44a2.88,2.88,0,0,1-2.1-.9A2.88,2.88,0,0,1,6,41V10a2.88,2.88,0,0,1,.9-2.1A2.88,2.88,0,0,1,9,7h3.25V4H15.5V7h17V4h3.25V7H39a2.88,2.88,0,0,1,2.1.9A2.88,2.88,0,0,1,42,10V25.05H39V19.5H9V41H25v3Zm35.45-11L40.9,29.5l1.45-1.45a1.58,1.58,0,0,1,2.1,0L45.9,29.5a1.58,1.58,0,0,1,0,2.1ZM28,46V42.45l10.8-10.8L42.3,35.2,31.5,46ZM9,16.5H39V10H9Zm0,0v0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.213346272669f30d7f2bd1754c5d1b31.svg";
export { ForwardRef as ReactComponent };